import { RecommendationContextProto } from "@noom/noom-contracts/noom_contracts/recommender/shared";
import getStore from "../redux/store";
import { trackBuyflowEvent } from "../api/tracker";
import { MED_SKU } from "../medEligibility";
import { PlanSelectionOption } from "src/pages/payment/results/medPlanSelection";

function getMedTierItemIdMap() {
  return {
    [MED_SKU.BRANDED_ZEPBOUND_VIAL]: "medBrandedZepboundVialPlan",
    [MED_SKU.BRANDED]: "medBrandedPlan",
    [MED_SKU.COMPOUNDED]: "medCompoundedPlan",
    [MED_SKU.GENERIC_LIRAGLUTIDE]: "medLiraglutidePlan",
    [MED_SKU.ORALS_METFORMIN]: "medOralsPlan",
    [MED_SKU.HRT_CREAM]: "hrtCreamPlan",
    [MED_SKU.HRT_PATCH]: "hrtPatchPlan",
    [MED_SKU.COMPOUNDED_MICRODOSE]: "medMicrodosePlan",
    [MED_SKU.COMPOUNDED_MICRODOSE_PROACTIVE_HEALTH_BIOMARKER]:
      "medProactiveHealthMicrodoseBiomarkerPlan",
  };
}

export function getRecommendationContextProto(
  option: PlanSelectionOption
): RecommendationContextProto {
  const { userData, recommendationContext } = getStore().getState();
  const growthUserId = userData.user_id;
  const recommendationId = recommendationContext?.recommendationId;

  if (option === "NOOM_WEIGHT") {
    return {
      itemId: "noomWeight",
      userId: { growthUserId },
      recommendationSurface: "MED_PLAN_OFFER",
      positionViewed: recommendationContext?.eligibleMedTiers?.length,
      recommendationId,
    };
  }

  const positionViewed =
    recommendationContext?.eligibleMedTiers?.indexOf(option);

  const medTierItemIdMap = getMedTierItemIdMap();

  return {
    itemId: medTierItemIdMap[option],
    userId: { growthUserId },
    recommendationSurface: "MED_PLAN_OFFER",
    positionViewed,
    recommendationId,
  };
}

export function trackRecommendedOfferClicked(option: PlanSelectionOption) {
  trackBuyflowEvent("BuyflowRecommendedItemClicked", {
    recommendationContext: getRecommendationContextProto(option),
  });
}

export function trackRecommendedOfferViewed(option: PlanSelectionOption) {
  trackBuyflowEvent("BuyflowRecommendedItemViewed", {
    recommendationContext: getRecommendationContextProto(option),
  });
}

export function trackRecommendedOfferDeclined(medTier: MED_SKU) {
  trackBuyflowEvent("BuyflowRecommendedItemDeclined", {
    recommendationContext: getRecommendationContextProto(medTier),
  });
}
